////////LIBRARY/////////
import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import moment from 'moment'
import { useSelector, shallowEqual, useDispatch } from 'react-redux'
import { bindActionCreators } from 'redux'
import { map, find, cloneDeep } from 'lodash'
///////COMPONENTS///////
import { notificationsActionCreators } from '../../store/actions'
import { TextModal, ButtonWrapper } from '../../theme/GlobalCss'
import Modals from '../Modals'
import theme from '../../theme/theme'
import Button from '../Ui/Buttons'
import 'moment/locale/fr'
/////////ASSETS/////////
import LogAlert from '../../assets/icones/notifications/bell.svg'
import Close from '../../assets/icones/global/close-white.svg'
import Validation from '../../assets/icones/global/check.svg'
import BlueBell from '../../assets/icones/notifications/bell-blue.svg'
import CloseNotif from '../../assets/icones/notifications/close-notif.svg'
import Exlam from '../../assets/icones/notifications/exlam-circle-yellow.svg'
import Warning from '../../assets/icones/global/warning-red.svg'
import Notif from '../../assets/icones/global/circle-green.svg'
import ArrowUp from '../../assets/icones/global/arrow-up.svg'
import ArrowDown from '../../assets/icones/global/arrow-down.svg'

/////////STYLED/////////
const LogAlertWrapper = styled.div`
	position: absolute;
	right: 32px;
`
const LogAlertImg = styled.img`
	cursor: pointer;
	height: 24px;
	background-color: ${(props) => props.theme.colors.buttons.dark};
	border-radius: 24px;
	padding: 10px 12px;
`
const RedCircleLogAlert = styled.div`
	position: absolute;
	display: flex;
	justify-content: center;
	align-items: center;
	width: 31px;
	height: 31px;
	text-align: center;
	border-radius: 100%;
	background-color: ${(props) => props.theme.colors.error};
	color: ${(props) => props.theme.colors.white};
	font-weight: 900;
	top: -10px;
	right: -10px;
	cursor: pointer;
`
const NotificationsWrapper = styled.div`
	height: max-content;
	width: 318px;
	position: absolute;
	top: 131%;
	right: -319px;
	transform: ${(props) => props.notificationWrapper && 'translateX(-100% )'};
	transition: 0.5s;
	background-color: ${(props) => props.theme.colors.secondary};
	box-shadow: -2px 0 6px rgba(0, 0, 0, 0.16);
`
const NotificationsPaper = styled.div`
	display: grid;
	grid-template-rows: 48px max-content;
	grid-template-columns: 236px 24px;
	grid-gap: 10px;
	background-color: ${(props) => props.theme.colors.secondary};
	box-shadow: -2px 0 6px rgba(0, 0, 0, 0.16);
	grid-template-areas:
		'header header'
		'body body';
`
const NotificationsHeader = styled.div`
	grid-area: header;
	display: grid;
	grid-template-rows: 1fr;
	grid-template-columns: 30px 140px 110px 31px;
`
const TitlePicto = styled.div`
	grid-column: 1/4;
	grid-row: 1;
	background-image: url(${BlueBell});
	background-position: left;
	background-repeat: no-repeat;
	margin-left: 7px;
`
const TitleText = styled.div`
	grid-column: 2/4;
	grid-row: 1;
	color: ${(props) => props.theme.colors.primary};
	font-size: ${(props) => props.theme.font.fxll};
	display: flex;
	align-items: center;
	justify-content: flex-start;
	font-weight: 900;
`
const NotifMassCloture = styled.div`
	grid-column: 3/4;
	grid-row: 1;
	width: max-content;
	cursor: pointer;
	color: ${(props) => props.theme.colors.hoverPrimary};
	text-decoration: underline;
	transition: background-color 0.1s;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-left: 5px;
`
const NotificationsCloseWrapper = styled.div`
	grid-column: 4/4;
	grid-row: 1;
	cursor: pointer;
	background-image: url(${CloseNotif});
	background-position: left;
	background-repeat: no-repeat;
	margin-left: 7px;
`
const BodyWrapper = styled.div`
    height:auto;
    width:126%;
    max-height:800px;
    overflow-y:auto;
    overflow-x: hidden;
	
::-webkit-scrollbar {
    width: 17px;
	height: 18px;
}
::-webkit-scrollbar-thumb {
    height: 6px;
    border-right: 10px solid rgba(0, 0, 0, 0);
    
	border-left:${(props) => props.theme.colors.backgroundScroll};
	border-top:${(props) => props.theme.colors.backgroundScroll},
	border-bottom:${(props) => props.theme.colors.backgroundScroll};
    background-clip: padding-box;
    background-color: ${(props) => props.theme.colors.eraser};
}
::-webkit-scrollbar-button:vertical:decrement:single-button {
	background: no-repeat${(props) => props.theme.colors.backgroundScroll};
	background-image: url(${ArrowUp});
	height:10px;
	background-position: center bottom;
    border-right: 10px solid white;
}
::-webkit-scrollbar-button:vertical:increment:single-button {
	background: no-repeat${(props) => props.theme.colors.backgroundScroll};
	background-image: url(${ArrowDown});
	height:10px;
	background-position: center bottom;
	border-right: 10px solid white;	
}
::-webkit-scrollbar-track-piece{
	background-color: ${(props) => props.theme.colors.backgroundScroll};
	border-right: 10px solid white;
}	
`
const NotificationsBody = styled.div`
	grid-area: body;
	width: 110%;
	background-color: ${(props) => props.theme.colors.secondary};
	display: grid;
	padding-top: 3px;
	margin-bottom: 2%;
	grid-template-rows: 17px 17px 50px;
	grid-template-columns: 1fr;
	grid-template-areas:
		'date '
		'type '
		'button';
`
const NotificationsDate = styled.div`
	grid-area: date;
	display: flex;
	flex-direction: row;
	margin-bottom: 9px;
	margin-left: 7px;
`
const IconWrapper = styled.div`
	height: auto;
	width: 20px;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-left: 17px;
	margin-right: 9px;
`
const IconNotif = styled.img`
	height: 16px;
	width: 16px;
`
const DateValue = styled.div`
	height: auto;
	width: max-content;
	display: flex;
	align-items: center;
	justify-content: center;
	font-weight: 900;
`
const NotificationsType = styled.div`
	grid-area: type;
	white-space: nowrap;
	color: ${(props) => props.theme.colors.primary};
	margin-top: 3px;
	margin-left: 7%;
	height: max-content;
`
const ButtonDetailWrapper = styled.div`
	grid-area: button;
	width: 87%;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-left: -5px;
`
const DetailLogWrapper = styled.div`
	height: auto;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-bottom: 7%;
`
const DetailLogPaper = styled.div`
	display: grid;
	grid-template-rows: repeat(5, 1fr);
	grid-template-columns: 1fr;
	grid-gap: 25px;
`
const HeaderContent = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: row;
`
const HeaderPicto = styled.img`
	height: 30px;
	width: 30px;
`
const HeaderText = styled.div`
	font-weight: 900;
	margin-left: 10px;
	padding-top: 4px;
`
const DateContent = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	font-weight: 900;
`
const CreatedContent = styled.div`
	display: grid;
	grid-template-rows: 1fr;
	grid-template-columns: 1fr 1fr;
`
const CategoryContent = styled.div`
	display: grid;
	grid-template-rows: 1fr;
	grid-template-columns: 1fr 1fr;
`
const CategoryContentGroupLeft = styled.div`
	grid-column: 1 / 2;
	grid-row: 1;
	display: flex;
	flex-direction: row;
`
const CategoryContentGroupRight = styled.div`
	grid-column: 2 / 2;
	grid-row: 1;
	display: flex;
	flex-direction: row;
`
const BottomContent = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
`
const TextBold = styled.div`
	font-weight: 900;
	margin-right: 2px;
`
const TextNormal = styled.div`
	margin-right: ${(props) => (props.margin ? `${props.margin}px` : '')};
`
/////////STYLED/////////

const Notifications = () => {
	const [notificationWrapper, setNotificationWrapper] = useState(false)
	const [showMassCloture, setShowMassCloture] = useState(false)
	const [showDetailLog, setShowDetailLog] = useState(false)
	const [idItem, setIdItem] = useState()
	const [detailLog, setDetailLog] = useState({})

	const { translations, notifications, user } = useSelector(
		(state) => ({
			user: state.user,
			translations: state.languages.translations,
			kioskPerimeter: state.kioskPerimeter,
			toastSuccess: state.toastSuccess,
			notifications: state.notifications.items,
		}),
		shallowEqual
	)

	const actionsNotifications = bindActionCreators(notificationsActionCreators, useDispatch())

	///////////////////////////////// HANDLE ///////////////////////////////////////

	const handleNotifications = () => {
		setNotificationWrapper(!notificationWrapper)
		//actionsNotifications.getLogsNotification()
	}

	const handleMassCloture = () => {
		setShowMassCloture(!showMassCloture)
	}

	// get log detail inside modal
	const handleDetailLog = (item) => {
		const notificationsCP = cloneDeep(notifications)
		setShowDetailLog(!showDetailLog)
		setIdItem(item)
		setDetailLog(find(notificationsCP, (n) => n.id === item))
	}

	const handleCloseModal = () => {
		if (showDetailLog) {
			setShowDetailLog(!showDetailLog)
		}
	}

	//******************ACTION *****************/

	const handleCloseNotif = (id) => {
		actionsNotifications.closeNotification(id)
		setShowDetailLog(!showDetailLog)
	}

	const handleCloseAllNotif = (ids) => {
		let collectionId = map(ids, (id) => id.id)
		actionsNotifications.closeAllNotification(collectionId)
		setShowMassCloture(!showMassCloture)
	}

	const handleResolvedLog = (id) => {
		actionsNotifications.updateResolvedLog(id)
		setShowDetailLog(!showDetailLog)
	}

	const handleReportLogs = (id) => {
		actionsNotifications.reportNotification(id)
		setShowDetailLog(!showDetailLog)
	}

	/////////////////////////////// USE EFFECT /////////////////////////////////////

	useEffect(() => {
		actionsNotifications.getLogsNotification()
	}, [])

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<>
			{/*NOTIFICATIONS*/}
			<NotificationsWrapper notificationWrapper={notificationWrapper}>
				<NotificationsPaper>
					<NotificationsHeader>
						<TitlePicto></TitlePicto>
						<TitleText>{translations['header__admin__notif_title']}</TitleText>
						{find(notifications, (n) => n.logLevel?.id === 6 || n.logLevel?.id === 1) && (
							<NotifMassCloture onClick={() => handleMassCloture()}>
								{translations['header__admin__notif__link_closeAll']}
							</NotifMassCloture>
						)}

						<NotificationsCloseWrapper onClick={() => handleNotifications()}></NotificationsCloseWrapper>
					</NotificationsHeader>
					<BodyWrapper size={notifications.length}>
						{map(notifications, (n, key) => (
							<NotificationsBody key={key}>
								<NotificationsDate>
									<IconWrapper>
										{n.logLevel?.id === 2 && <IconNotif src={Exlam}></IconNotif>}
										{n.logLevel?.id === 3 && <IconNotif src={Warning}></IconNotif>}
										{n.logLevel?.id === 6 || (n.logLevel?.id === 1 && <IconNotif src={Notif}></IconNotif>)}
									</IconWrapper>
									<DateValue>{moment(n.dateCreated).locale('fr').format('ddd DD/MM/YY - HH:mm:ss')}</DateValue>
								</NotificationsDate>
								<NotificationsType>{n.logEvent?.label}</NotificationsType>
								<ButtonDetailWrapper>
									<Button
										actionHandler={() => handleDetailLog(n.id)}
										bgColor={theme.colors.primary}
										text={translations['header__admin__notif__button__seeDetail']}
										width={227}
										height={36}
										weight={'bold'}
									/>
								</ButtonDetailWrapper>
							</NotificationsBody>
						))}
					</BodyWrapper>
				</NotificationsPaper>
			</NotificationsWrapper>

			{/*MODAL MASS CLOTURE*/}
			<Modals
				showModal={showMassCloture}
				closeModalHandler={handleMassCloture}
				maxWidth={555}
				level="error"
				icon={true}
				title={translations['header__admin__notif__modal__deleteAll_title']}
			>
				<TextModal>{translations['header__admin__notif__modal__deleteAll__text_warning']}</TextModal>
				<ButtonWrapper>
					<Button
						actionHandler={() => handleMassCloture()}
						img={Close}
						bgColor={theme.colors.error}
						text={translations['header__admin__notif__modal__detail__button_cancel']}
					/>
					<Button
						actionHandler={() => handleCloseAllNotif(notifications.filter((n) => n.logLevel.id === 6 || n.logLevel.id === 1))}
						text={translations['header__admin__notif__modal__deleteAll__button_close']}
						bgColor={theme.colors.validation}
						img={Validation}
					/>
				</ButtonWrapper>
			</Modals>

			{/*MODAL DETAIL LOG*/}
			<Modals
				showModal={showDetailLog}
				closeModalHandler={handleCloseModal}
				maxWidth={655}
				title={translations['header__admin__notif__modal__detail_title']}
				icon={true}
			>
				<DetailLogWrapper>
					<DetailLogPaper>
						<HeaderContent>
							{detailLog?.logLevel?.id === 2 && <HeaderPicto src={Exlam}></HeaderPicto>}
							{detailLog?.logLevel?.id === 3 && <HeaderPicto src={Warning}></HeaderPicto>}
							{detailLog?.logLevel?.id === 6 || (detailLog?.logLevel?.id === 1 && <HeaderPicto src={Notif}></HeaderPicto>)}

							<HeaderText>{translations[detailLog?.logLevel?.translationKey]}</HeaderText>
						</HeaderContent>
						<DateContent>{`[${moment(detailLog?.dateCreated).format('DD/MM/YYYY - HH:mm:ss')} - ${
							detailLog?.logEvent?.label
						}]`}</DateContent>
						<CreatedContent>
							<CategoryContentGroupLeft>
								<TextBold>{translations['header__admin__notif__modal__detail__text_id']} :</TextBold>
								<TextNormal argin={35}>{detailLog?.id}</TextNormal>
							</CategoryContentGroupLeft>
							<CategoryContentGroupRight>
								<TextBold>{translations['header__admin__notif__modal__detail__text_createdBy']} :</TextBold>
								<TextNormal m>{`${detailLog?.createdBy?.firstName} ${detailLog?.createdBy?.lastName}`}</TextNormal>
							</CategoryContentGroupRight>
						</CreatedContent>
						<CategoryContent>
							<CategoryContentGroupLeft>
								<TextBold>{translations['header__admin__notif__modal__detail__text_category']} :</TextBold>
								<TextNormal margin={35}>{translations[detailLog?.logCategorie?.translationKey]}</TextNormal>
							</CategoryContentGroupLeft>
							<CategoryContentGroupRight>
								<TextBold>{translations['header__admin__notif__modal__detail__text_subCategory']} :</TextBold>
								<TextNormal>{translations[detailLog?.logSubCategorie?.translationKey]}</TextNormal>
							</CategoryContentGroupRight>
						</CategoryContent>
						<BottomContent>{detailLog?.message}</BottomContent>
					</DetailLogPaper>
				</DetailLogWrapper>

				<ButtonWrapper>
					<Button
						actionHandler={() => handleCloseModal()}
						img={Close}
						bgColor={theme.colors.error}
						text={translations['header__admin__notif__modal__detail__button_cancel']}
					/>
					{detailLog?.logLevel?.id === 6 ||
						(detailLog?.logLevel?.id === 1 && (
							<Button
								actionHandler={() => handleCloseNotif(detailLog?.id)}
								text={translations['header__admin__notif__modal__detail__button_close']}
								bgColor={theme.colors.validation}
								img={Validation}
							/>
						))}
					{detailLog?.logLevel?.id === 2 && (
						<Button
							actionHandler={() => handleResolvedLog(detailLog?.id)}
							text={translations['header__admin__notif__modal__detail__button_resolved']}
							bgColor={theme.colors.validation}
							img={Validation}
						/>
					)}
					{detailLog?.logLevel?.id === 3 && (
						<Button
							actionHandler={() => handleResolvedLog(detailLog?.id)}
							text={translations['header__admin__notif__modal__detail__button_resolved']}
							bgColor={theme.colors.validation}
							img={Validation}
						/>
					)}
					{detailLog?.logLevel?.id === 2 && user.identity.company.companyTyped.idCompanyType !== 5 && (
						<Button
							actionHandler={() => handleReportLogs(detailLog?.id)}
							text={translations['header__admin__notif__modal__detail__button_report']}
							bgColor={theme.colors.warning}
							img={Validation}
						/>
					)}
					{detailLog?.logLevel?.id === 3 && user.identity.company.companyTyped.idCompanyType !== 5 && (
						<Button
							actionHandler={() => handleReportLogs(detailLog?.id)}
							text={translations['header__admin__notif__modal__detail__button_report']}
							bgColor={theme.colors.warning}
							img={Validation}
						/>
					)}
				</ButtonWrapper>
			</Modals>

			<LogAlertWrapper>
				<LogAlertImg src={LogAlert} onClick={() => handleNotifications()} />
				{notifications && notifications.length > 0 && (
					<RedCircleLogAlert onClick={() => handleNotifications()}>
						{notifications.length > 98 ? '99+' : `${notifications.length}`}
					</RedCircleLogAlert>
				)}
			</LogAlertWrapper>
		</>
	)
}

Notifications.propTypes = {}

export default Notifications
